import type { Components, Theme } from "@mui/material/styles";
import { BUTTON_SIZE_STYLES } from "./button-size-styles";
import { buttonRootStyles, containedMap, ghostMap, ghostUnderlineMap, outlinedMap } from "./styles";

// Please follow guidelines https://www.figma.com/design/zzvO7fdaTfLvgTSrb6ypCs/wikifolio-UI-Library?node-id=0-847&p=f&m=dev

/**
 * Mirrors the variant/color keys registered in `ButtonPropsVariantOverrides` /
 * `ButtonPropsColorOverrides` in `src/theme-mui/index.d.ts` — keep both in sync.
 */
export type ButtonVariant = "text" | "contained" | "outlined" | "ghost" | "ghost-underline";
export type ButtonColor = "gray" | "green" | "whiteAlpha";

export { BUTTON_SIZE_STYLES } from "./button-size-styles";
export type { ButtonSize } from "./button-size-styles";

export const MuiButton: Components<Theme>["MuiButton"] = {
    defaultProps: {
        variant: "contained",
        color: "gray",
    },
    styleOverrides: {
        root: {
            ...buttonRootStyles,
            variants: [
                {
                    props: { variant: "contained", color: "gray" },
                    style: containedMap.gray,
                },
                {
                    props: { variant: "contained", color: "green" },
                    style: containedMap.green,
                },
                {
                    props: { variant: "contained", color: "whiteAlpha" },
                    style: containedMap.whiteAlpha,
                },

                {
                    props: { variant: "outlined", color: "gray" },
                    style: outlinedMap.gray,
                },
                {
                    props: { variant: "outlined", color: "green" },
                    style: outlinedMap.green,
                },
                {
                    props: { variant: "ghost", color: "gray" },
                    style: ghostMap.gray,
                },
                {
                    props: { variant: "ghost", color: "green" },
                    style: ghostMap.green,
                },
                {
                    props: { variant: "ghost-underline", color: "gray" },
                    style: ghostUnderlineMap.gray,
                },
                {
                    props: { variant: "ghost-underline", color: "green" },
                    style: ghostUnderlineMap.green,
                },
            ],
            // Disable transitions when loading wrapper is present
            "&:has(.MuiButton-loadingWrapper)": {
                transition: "none",
                "& *": {
                    transition: "none",
                },
            },
            "&.MuiButton-loading": {
                cursor: "not-allowed",
                border: "1px solid currentColor",
                "& > *:not(.MuiButton-loadingWrapper)": {
                    opacity: 0,
                },
                "& .MuiButton-loadingWrapper": {
                    display: "contents",
                    "& .MuiButton-loadingIndicator": {
                        fontSize: "initial",
                        color: "inherit",
                    },
                },
            },
        },
        endIcon: {
            marginRight: 0,
        },
        sizeExtraSmall: BUTTON_SIZE_STYLES.extraSmall,
        sizeSmall: BUTTON_SIZE_STYLES.small,
        sizeMedium: BUTTON_SIZE_STYLES.medium,
        sizeLarge: BUTTON_SIZE_STYLES.large,
    },
};
